import styled from '@emotion/styled'

export const Form = styled.form`
  place-self: start center;
  display: grid;
  width: 100%;
  gap: 14px;
  flex-direction: column;
  align-items: center;


  & > input:-webkit-autofill, & > input:-webkit-autofill:hover, & > input:-webkit-autofill:focus, & > input:-webkit-autofill:active {
    background: #06223A;
  !important;
    box-shadow: inset -6.22302px -6.22302px 6.22302px #1e3143, inset 3.73381px 3.73381px 6.22302px #000000 !important;
  }
`
export const InputContainer = styled.div`
  width: 60%;
  place-self: center;
  height: 60px;
`
export const Label = styled.div`
  padding-left: 10px;
`
export const ButtonContainer = styled.div`
  place-self: center;
  width: 65%;
  display: grid;
  padding-top: 30px;
`
